import axios from "axios"
import { Dispatch } from "redux"

const enum MerchantCodesByRateActionsEnum {
  GET_MERCHANT_CODES_BY_RATE_ATTEMPT = "MERCHANT_CODES_BY_RATE/getMerchantCodesByRateAttempt",
  GET_MERCHANT_CODES_BY_RATE_SUCCESS = "MERCHANT_CODES_BY_RATE/getMerchantCodesByRateSuccess",
  GET_MERCHANT_CODES_BY_RATE_ERROR = "MERCHANT_CODES_BY_RATE/getMerchantCodesByRateError",
  GET_ALL_MERCHANT_CODES_BY_RATE_ATTEMPT = "MERCHANT_CODES_BY_RATE/getAllMerchantCodesByRateAttempt",
  GET_ALL_MERCHANT_CODES_BY_RATE_SUCCESS = "MERCHANT_CODES_BY_RATE/getAllMerchantCodesByRateSuccess",
  GET_ALL_MERCHANT_CODES_BY_RATE_ERROR = "MERCHANT_CODES_BY_RATE/getAllMerchantCodesByRateError",
  UPDATE_MERCHANT_CODES_BY_RATE_RESET = "MERCHANT_CODES_BY_RATE/updateMerchantCodesByRateReset",
  UPDATE_MERCHANT_CODES_BY_RATE_ATTEMPT = "MERCHANT_CODES_BY_RATE/updateMerchantCodesByRateAttempt",
  UPDATE_MERCHANT_CODES_BY_RATE_SUCCESS = "MERCHANT_CODES_BY_RATE/updateMerchantCodesByRateSuccess",
  UPDATE_MERCHANT_CODES_BY_RATE_ERROR = "MERCHANT_CODES_BY_RATE/updateMerchantCodesByRateError",
  EDIT_MERCHANT_CODES_BY_RATE = "MERCHANT_CODES_BY_RATE/editMerchantCodesByRate",
}

export const getMerchantCodesByRateAttemptAction = () =>
  ({
    type: MerchantCodesByRateActionsEnum.GET_MERCHANT_CODES_BY_RATE_ATTEMPT,
  } as const)

export const getMerchantCodesByRateSuccessAction = (
  payload: MerchantCodeByRate[]
) =>
  ({
    type: MerchantCodesByRateActionsEnum.GET_MERCHANT_CODES_BY_RATE_SUCCESS,
    payload,
  } as const)

export const getMerchantCodesByRateErrorAction = () =>
  ({
    type: MerchantCodesByRateActionsEnum.GET_MERCHANT_CODES_BY_RATE_ERROR,
  } as const)

export const getAllMerchantCodesByRateAttemptAction = () =>
  ({
    type: MerchantCodesByRateActionsEnum.GET_ALL_MERCHANT_CODES_BY_RATE_ATTEMPT,
  } as const)

export const getAllMerchantCodesByRateSuccessAction = (
  payload: MerchantCodeByRate[]
) =>
  ({
    type: MerchantCodesByRateActionsEnum.GET_ALL_MERCHANT_CODES_BY_RATE_SUCCESS,
    payload,
  } as const)

export const getAllMerchantCodesByRateErrorAction = () =>
  ({
    type: MerchantCodesByRateActionsEnum.GET_ALL_MERCHANT_CODES_BY_RATE_ERROR,
  } as const)

export const updateMerchantCodesByRateResetAction = () =>
  ({
    type: MerchantCodesByRateActionsEnum.UPDATE_MERCHANT_CODES_BY_RATE_RESET,
  } as const)

export const updateMerchantCodesByRateAttemptAction = () =>
  ({
    type: MerchantCodesByRateActionsEnum.UPDATE_MERCHANT_CODES_BY_RATE_ATTEMPT,
  } as const)

export const updateMerchantCodesByRateSuccessAction = (
  payload: MerchantCodeByRate[]
) =>
  ({
    type: MerchantCodesByRateActionsEnum.UPDATE_MERCHANT_CODES_BY_RATE_SUCCESS,
    payload,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey:
        "office.modify-merchant.merchant-codes-by-rate.toast.update.success.title",
      bodyKey:
        "office.modify-merchant.merchant-codes-by-rate.toast.update.success.body",
    },
  } as const)

export const updateMerchantCodesByRateErrorAction = () =>
  ({
    type: MerchantCodesByRateActionsEnum.UPDATE_MERCHANT_CODES_BY_RATE_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey:
        "office.modify-merchant.merchant-codes-by-rate.toast.update.error.title",
      bodyKey:
        "office.modify-merchant.merchant-codes-by-rate.toast.update.error.body",
    },
  } as const)

export const editMerchantCodesByRateAction = (payload: MerchantCodeByRate[]) =>
  ({
    type: MerchantCodesByRateActionsEnum.EDIT_MERCHANT_CODES_BY_RATE,
    payload,
  } as const)

type MerchantCodesByRateActionsType = ReturnType<
  | typeof getMerchantCodesByRateAttemptAction
  | typeof getMerchantCodesByRateSuccessAction
  | typeof getMerchantCodesByRateErrorAction
  | typeof getAllMerchantCodesByRateAttemptAction
  | typeof getAllMerchantCodesByRateSuccessAction
  | typeof getAllMerchantCodesByRateErrorAction
  | typeof updateMerchantCodesByRateAttemptAction
  | typeof updateMerchantCodesByRateSuccessAction
  | typeof updateMerchantCodesByRateErrorAction
  | typeof editMerchantCodesByRateAction
>

export const merchantCodesByRateInitialState: MerchantCodesByRateState = {
  merchant_codes_by_rates: [],
  merchant_codes_by_rates_for_merchant: [],
  edited_merchant_codes_by_rates: [],
  updateMerchantCodesByRateStatus: "idle",
}

export interface MerchantCodesByRateState {
  merchant_codes_by_rates: MerchantCodeByRate[]
  merchant_codes_by_rates_for_merchant: MerchantCodeByRate[]
  edited_merchant_codes_by_rates: MerchantCodeByRate[]
  updateMerchantCodesByRateStatus: "idle" | "loading" | "success" | "error"
}

export const autoliquidatedTypes = [
  "eu",
  "construction",
  "eu_goods",
  "world",
  "world_goods",
  "custom",
  "deposit",
  "reverse_deposit",
] as const

export type AutoliquidatedType = (typeof autoliquidatedTypes)[number]

export function merchantCodesByRateReducer(
  state = merchantCodesByRateInitialState,
  action: MerchantCodesByRateActionsType
): MerchantCodesByRateState {
  switch (action.type) {
    case MerchantCodesByRateActionsEnum.GET_MERCHANT_CODES_BY_RATE_ATTEMPT:
      return { ...state, merchant_codes_by_rates_for_merchant: [] }
    case MerchantCodesByRateActionsEnum.GET_MERCHANT_CODES_BY_RATE_SUCCESS:
      return { ...state, merchant_codes_by_rates_for_merchant: action.payload }
    case MerchantCodesByRateActionsEnum.GET_ALL_MERCHANT_CODES_BY_RATE_ATTEMPT:
      return { ...state, merchant_codes_by_rates: [] }
    case MerchantCodesByRateActionsEnum.GET_ALL_MERCHANT_CODES_BY_RATE_SUCCESS:
      return { ...state, merchant_codes_by_rates: action.payload }
    case MerchantCodesByRateActionsEnum.GET_ALL_MERCHANT_CODES_BY_RATE_ERROR:
      return { ...state }
    case MerchantCodesByRateActionsEnum.UPDATE_MERCHANT_CODES_BY_RATE_RESET:
      return { ...state, updateMerchantCodesByRateStatus: "idle" }
    case MerchantCodesByRateActionsEnum.UPDATE_MERCHANT_CODES_BY_RATE_ATTEMPT:
      return { ...state, updateMerchantCodesByRateStatus: "loading" }
    case MerchantCodesByRateActionsEnum.UPDATE_MERCHANT_CODES_BY_RATE_SUCCESS:
      return { ...state, updateMerchantCodesByRateStatus: "success" }
    case MerchantCodesByRateActionsEnum.UPDATE_MERCHANT_CODES_BY_RATE_ERROR:
      return { ...state, updateMerchantCodesByRateStatus: "error" }
    case MerchantCodesByRateActionsEnum.EDIT_MERCHANT_CODES_BY_RATE:
      return { ...state, edited_merchant_codes_by_rates: action.payload }
    default:
      return { ...state }
  }
}

export interface MerchantCodeByRate {
  vat_rate_id: number | null
  autoliquidated_type: AutoliquidatedType | null
  id: number | null
  merchant_code_id: number | null
  merchant_id: number | null
  vat_rate_value: string
  merchant_code_value: string
}

export const getMerchantCodesByRateThunk =
  ({ merchantId, companyId }: { merchantId: number; companyId: number }) =>
  (dispatch: Dispatch<MerchantCodesByRateActionsType>) => {
    dispatch(getMerchantCodesByRateAttemptAction())
    return axios
      .get<MerchantCodeByRate[]>(`merchant_codes_by_rate/get_by_merchant`, {
        params: {
          merchant_id: merchantId,
          company_id: companyId,
        },
      })
      .then((response) => {
        dispatch(getMerchantCodesByRateSuccessAction(response.data))
      })
      .catch(() => {
        dispatch(getMerchantCodesByRateErrorAction())
      })
  }

export const updateMerchantCodesByRateThunk =
  ({
    merchantId,
    companyId,
    merchantCodeByRate,
  }: {
    merchantId: number
    companyId: number
    merchantCodeByRate: MerchantCodeByRate[]
  }) =>
  (dispatch: Dispatch<MerchantCodesByRateActionsType>) => {
    dispatch(updateMerchantCodesByRateAttemptAction())
    return axios
      .put<MerchantCodeByRate[]>(
        `merchant_codes_by_rate/update_merchant_codes_by_rate`,
        {
          merchant_id: merchantId,
          company_id: companyId,
          merchant_codes_by_rates: merchantCodeByRate,
        }
      )
      .then((response) => {
        dispatch(updateMerchantCodesByRateSuccessAction(response.data))
      })
      .catch(() => {
        dispatch(updateMerchantCodesByRateErrorAction())
      })
  }

export const getAllMerchantCodesByRateThunk =
  ({ companyId }: { companyId: number }) =>
  (dispatch: Dispatch<MerchantCodesByRateActionsType>) => {
    dispatch(getAllMerchantCodesByRateAttemptAction())
    return axios
      .get<MerchantCodeByRate[]>(
        `merchant_codes_by_rate/get_all_merchant_codes_by_rate`,
        {
          params: {
            company_id: companyId,
          },
        }
      )
      .then((response) => {
        dispatch(getAllMerchantCodesByRateSuccessAction(response.data))
      })
      .catch(() => {
        dispatch(getAllMerchantCodesByRateErrorAction())
      })
  }
